import { useEffect, useMemo } from 'react'
import { LOCALSTORAGE_RECENTLY_VIEWED_PRODUCTS } from '../../constants'
import { useConfig } from '../../providers/config'
import { useLocalStorage } from '../useLocalStorage'
import { useProducts } from './useProducts'
import { useSortCollection } from '../useSortCollection'
import { useCurrency } from '../../providers/currency'
import { useTrackingsActions } from '../trackings'

export const useRecentlyViewedProducts = ({ id, tracking = true, pageContext, pageId, widgetContext }) => {
	const {
		catalog: {
			products: {
				recentlyViewed: { limit: recentlyViewedLimit },
			},
		},
	} = useConfig()

	const { currency } = useCurrency()
	const { productImpressions } = useTrackingsActions()

	const [storageValue] = useLocalStorage(LOCALSTORAGE_RECENTLY_VIEWED_PRODUCTS, [])

	const recentlyViewedProductIds = storageValue?.filter((productId) => productId !== id)

	const { products, error, loading, mutate, cancel, cancelled } = useProducts({
		limit: recentlyViewedLimit,
		offset: 0,
		where: {
			id: {
				inq: recentlyViewedProductIds,
			},
		},
		paused: recentlyViewedProductIds.length === 0,
	})

	const recentlyViewedProducts = useSortCollection({
		collection: products,
		sortedValues: recentlyViewedProductIds,
	})

	const memoizedRecentlyViewedProducts = useMemo(
		() => recentlyViewedProducts,
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[recentlyViewedProducts.map((product) => product.id).join(',')]
	)

	useEffect(() => {
		if (memoizedRecentlyViewedProducts?.length && tracking) {
			productImpressions({ products: memoizedRecentlyViewedProducts, currency, pageContext, pageId, widgetContext })
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [memoizedRecentlyViewedProducts, productImpressions, currency, pageContext, pageId, widgetContext])

	return {
		recentlyViewedProductIds,
		recentlyViewedProducts,
		loading,
		error,
		mutate,
		cancel,
		cancelled,
	}
}
